// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__CLYHD","headerLink":"Navbar_headerLink__31pPd"};